import React, {useMemo} from 'react';
import {Cell, Legend, Pie, PieChart, Tooltip} from 'recharts';

const colors = [
  "#9cd08f", "#684551", "#cea0ae", "#d5b0ac", "#c7d3bf", "#807182",
  "#d8aa96", "#f7b1ab", "#ffc9b5", "#735d78", "#b392ac", "#d1b3c4",
  "#e8c2ca", "#f7d1cd", "#72ddf7", "#8093f1", "#b388eb", "#f7aef8",
  "#fdc5f5", "#55828b", "#87bba2", "#c9e4ca", "#fbb02d", "#5c8001",
  "#7cb518", "#f3de2c",
];

let usedColors = [];

const getRandomColor = () => {
  if (usedColors.length === colors.length) {
    usedColors = []; // Reset usedColors array if all colors are used
  }
  let colorIndex;
  do {
    colorIndex = Math.floor(Math.random() * colors.length);
  } while (usedColors.includes(colorIndex));
  usedColors.push(colorIndex);
  return colors[colorIndex];
};

const prepareData = (data) => {
  return data.map((entry) => ({
    name: entry.Sector,
    value: entry.Exposure * 100,
    color: getRandomColor(),
  }));
};

const CustomTooltip = ({ payload }) => {
  if (!payload || payload.length === 0) {
    return null;
  }

  return (
    <div className="custom-tooltip">
      {payload.map((entry, index) => {
        return (
          <p key={index} style={{ fontWeight: 'bold' }}>
            {entry.name}: {entry.value.toFixed(2)}%
          </p>
        );
      })}
    </div>
  );
};

const CustomLegend = (props) => {
  const { payload } = props;
  return (
    <ul className="recharts-default-legend">
      {payload.map((entry, index) => (
        <li key={`item-${index}`} className="legend-item">
          <svg width="10" height="10">
            <rect width="10" height="10" fill={entry.color} />
          </svg>
          <span>{entry.value}</span>
        </li>
      ))}
    </ul>
  );
};

const Chart = ({ data }) => {
  const fixedData = useMemo(() => prepareData(data), [data]);

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  return (
    <PieChart width={300} height={300}>
      <Pie
        data={fixedData}
        cx="50%"
        cy="50%"
        labelLine={true}
        label={false}
        outerRadius={80}
        dataKey="value"
        nameKey="name"
      >
        {fixedData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Pie>
      <Tooltip content={<CustomTooltip />} />
      <Legend content={<CustomLegend />} />
    </PieChart>
  );
};

export default Chart;
